/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipperGoodsFormCancel: "shipper-goods-form-cancel",
  shipperGoodsFormValidate: "shipper-goods-form-validate",
} as const;
